<template>
  <div style="padding: 30px">
    <v-row>
      <v-col sm="12">
        Would you like to purchase a mulligan package to support the Florida Vascular Foundations?
      </v-col>

    </v-row>

    <v-row>
      <v-col sm="6">
        <v-btn-toggle rounded v-model="mulligan_pack.amount">

          <v-btn value="50">
            1 for $50
          </v-btn>
          <v-btn value="125">
            3 for $125
          </v-btn>
          <v-btn value="200">
            5 for $200
          </v-btn>

        </v-btn-toggle>
      </v-col>
      <v-col sm="6">
        <v-text-field
            style="max-width: 300px"
            label="Custom Amount"
            prepend-icon="mdi-currency-usd"
            outlined
            v-model="mulligan_pack.amount"
        ></v-text-field>


      </v-col>
    </v-row>


  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: "MulliganPack",

  computed: {
    ...mapState({
      // donator: state => state.donator,
      mulligan_pack: state => state.mulligan_pack
    })
  },


}
</script>

<style scoped>

</style>